import { useSubscription } from "@apollo/client";
import { GET_SITE_CHANNEL_EVENTS } from "../../graphql/subscription";

const extractEvent = (data) => data?.siteChannelEvents;

const useSiteChannelEventsSubscription = ({ onError, onUpdate }) => {

  const { loading } = useSubscription(
    GET_SITE_CHANNEL_EVENTS,
    {
      onComplete: () => {
        console?.info("** Completed subscription: SiteChannelEventsSubscription");
      },
      onData: (options) => {
        const event = extractEvent(options?.data);
        console?.info("** Subscription update: SiteChannelEventsSubscription", { event });
        onUpdate?.(event);
      },
      onError: (error) => {
        console?.error("** Subscription error: SiteChannelEventsSubscription", { error });
        onError?.(error);
      },
      variables: {
        authToken: localStorage.getItem("access_token"),
      },
    });

  return { loading };

};

export default useSiteChannelEventsSubscription;
